<button mat-menu-item (click)="clickPerformEvaluations()" type="button">
  <mat-icon class="toolbar-icon">analytics</mat-icon>
  <span>{{ 'dataEvaluation.performEvaluations.title' | translate }}</span>
</button>

<button mat-menu-item (click)="clickViewEvaluations()" type="button">
  <mat-icon class="toolbar-icon">preview</mat-icon>
  <span>{{ 'dataEvaluation.viewEvaluations.title' | translate }}</span>
</button>
